module.exports = __webpack_public_path__ + "img/campana-alt.757ac2ff.png";